module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA1CAYAAAAJZhZbAAAACXBIWXMAAC4jAAAuIwF4pT92AAABJklEQVRoge3bwU3DQBQG4X8RBdABlEAHgQ4ogVIohRLogLgDSoBKHrIUISv4kDk8K5D5jlHitUe7m4t3JHmJTjLHKlOd5uov3OS5MBZgLOB65atfSV7P9o6385zkdjna2gY/VdXDP3x4ZIyxT7Jb/sZlCBgLMBZgLMBYgLEAYwHGAowFGAswFmAswFiAsQBjAcYCjAUYCzAWYCzAWICxAGMBxgKMBRgLMBZgLMBYgLEAYwHGAowFGAswFrD2Au7NGOPi3ymdOxx/4AkLwGUIGAswFjBv8FPj9e+OTyk0m0+HfHYNMar69vfDv+p72wC/PVbVvuvircvwcOOdM3dp6gyVjfasrU7Kto/THmuj2dU+q9K9Z/0MMsZ9kqfGId6q6qPx+kmSb5aRMP4XRnwDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/images/tv-blk.png
// module id = 2410
// module chunks = 0